export default __webpack_public_path__ + "static/hp-pharmaco-ferritin-chart-SM-684d91dfe69311bf1496bd5ab8cae0ad.png";